import { TableComment } from "../../../../general/src/TableComment";
import { DataHeader, DataSource, Layout, Switch, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutOfficeRecurringPayAdjustment extends Layout {
    dataheaderOfficeRecurringPayAdjustment: DataHeader;
    layoutTableComment: TableComment;
    sourceComments: DataSource;
    sourceOffRecurDeduct: DataSource;
    switchSubjectToFedMin: Switch;
    tabComments: Tab;
    tabGarnishments: Tab;
    tabGeneral: Tab;
    tabsetOfficeRecurringPayAdjustment: Tabset;
    textboxAmount: Textbox;
    textboxCurrency: Textbox;
    textboxCycleId: Textbox;
    textboxDeductCodeId: Textbox;
    textboxDeductCodecodeType: Textbox;
    textboxDeductEndDate: Textbox;
    textboxDeductStartDate: Textbox;
    textboxDeductionType: Textbox;
    textboxFrequency: Textbox;
    textboxGarnishArrears: Textbox;
    textboxGarnishCaseNo: Textbox;
    textboxGarnishCurrent: Textbox;
    textboxGarnishNetAmt: Textbox;
    textboxGarnishOrderNo: Textbox;
    textboxGarnishPercent: Textbox;
    textboxGarnishPriority: Textbox;
    textboxGlid: Textbox;
    textboxLastTaken: Textbox;
    textboxLoanBalance: Textbox;
    textboxOrigLoanAmt: Textbox;
    textboxPayeeId: Textbox;
    textboxPercentage: Textbox;
    textboxReadyToPayFlag: Textbox;
    textboxReferenceNo: Textbox;
    textboxShortDesc: Textbox;
    textboxTotalToDate: Textbox;
    textboxVendorId: Textbox;
}
